import { TFilterDictionary, TServiceData, TStatus } from 'common/types'

import { MyServiceFilters, TServiceItems, TFilters } from '../types/MyServices.types'
import { FILTER_DICTIONARY } from '../utils/constants'

export function filterServices({
  filterDictionary,
  filters,
  items,
}: {
  filterDictionary?: TFilterDictionary
  filters: MyServiceFilters
  items: TServiceItems[]
}) {
  return items.filter((item) => {
    if (filters.subject && item.subject !== filters.subject) return false

    if (!filterDictionary || !filters.status || filters.status === filterDictionary.ALL) return true

    const itemStatus =
      (FILTER_DICTIONARY[item.status as TStatus] as TFilters) ??
      FILTER_DICTIONARY.AWAITING_SALESFORCE_TICKET_CREATION

    return filterDictionary[itemStatus] === filters.status
  })
}

export function prepareServices(services?: TServiceData[], filterDictionary?: TFilterDictionary) {
  if (!services || !filterDictionary) return []

  return services
    .map((service) => {
      const statusKey = service.status
      const itemStatus = FILTER_DICTIONARY[statusKey] as TFilters
      const translatedStatus =
        filterDictionary[itemStatus ?? FILTER_DICTIONARY.AWAITING_SALESFORCE_TICKET_CREATION]
      const lastSeen = new Date(service.lastSeen)
      const updatedAt = new Date(service.updatedAt)

      let icon = 'core/status/ic_close_circle'

      if (translatedStatus === filterDictionary.CANCELED) icon = 'core/status/ic_warning_circle'
      if (translatedStatus === filterDictionary.COMPLETED) icon = 'core/action-navigation/ic_check'
      if (translatedStatus === filterDictionary.UNDER_REVIEW)
        icon = 'core/action-navigation/ic_clock'

      // AQUI MOCK

      const hasUpdate = updatedAt > lastSeen
      return {
        ...service,
        status: itemStatus ? statusKey : 'AWAITING_SALESFORCE_TICKET_CREATION',
        hasUpdate,
        icon,
      } as TServiceItems
    })
    .sort((a, b) => {
      if (a.openingDate < b.openingDate) return 1
      if (a.openingDate > b.openingDate) return -1
      return 0
    })
}

export function getChips(filterDictionary?: TFilterDictionary) {
  if (!filterDictionary) return []

  const keys = Object.keys(filterDictionary).sort((a, b) => {
    if (a < b) return -1
    if (a > b) return 1
    return 0
  })

  return keys.map((key) => filterDictionary[key as keyof TFilterDictionary])
}
